module.exports = __webpack_public_path__ + "static/media/7_Up_7_Down.e037aecc.png";